// extracted by css-extract-rspack-plugin
export default {"line":"_e5955fa7"};